import React, { useEffect }  from 'react';
import { useTranslation } from 'react-i18next';
import { App } from '../../../models/app';
import { ActionButtonProps, AppActions } from './types';
import { getAppLaunchUrl, isOpenAppDisabled } from '../../../component-helpers/app-actions';
import { ButtonVariant, CoreButton } from '@clover/web-lib-core/components';
import { TextButton } from '../../Common/TextButton';
import { useMerchantDelinquencyStatus } from '../../../hooks/useMerchantDelinquencyStatus';
import { isOnlyAndroidApp } from '../../../component-helpers/app-details';
import { getAppDetailsRedirectedInfo, removeAppDetailsRedirectedInfo, } from '../../../utils/session';

interface ComponentProps extends ActionButtonProps {
  app: App;
  actionHandler?: () => void;
}

export const OpenAppButton: React.FC<ComponentProps> = (
  {
    app,
    actionHandler,
    buttonVariant,
    isMenuItem,
    text,
    ...rest
  }): Nullable<JSX.Element> => {
  const { t } = useTranslation();
  const isMerchantDelinquent = useMerchantDelinquencyStatus();
  const isDisabled = isOpenAppDisabled(app, isMerchantDelinquent);
  const isAndroid = isOnlyAndroidApp(app);
  const buttonText = text ? t(text) : isAndroid ? t(AppActions.OpenOnDevice) : t(AppActions.Open);

  const openApp = async () => {
    const launchUrl = getAppLaunchUrl(app);
    if (launchUrl) window.open(launchUrl, '_blank');
  };

  const { autoInstall,subscriptionId} = getAppDetailsRedirectedInfo();
  useEffect(() => {
    if (autoInstall && app?.installed) {
      /* when redirected from loggedout state to AppDetails Page
      The app is already installed but subscription pricing selected by merchant is diff */
      if (subscriptionId !== app?.currentSubscription?.id) {
        actionHandler?.();
      } else {
       /*  Delete the redirected information if app already installed
        & subscription pricing selected by user is same as the one installed */
        removeAppDetailsRedirectedInfo();
      }
    }
  }, [autoInstall,app,subscriptionId,actionHandler]);

  return (
    isMenuItem ?
      <TextButton onClick={openApp} text={buttonText} {...rest}/> :
      <CoreButton
        variant={buttonVariant !== undefined ? buttonVariant : ButtonVariant.PRIMARY}
        onClick={openApp}
        disabled={isDisabled}
        {...rest}
      >
        {buttonText}
      </CoreButton>
  );
};
